// test1760
(1760 && 0);
